import { Grid } from '@custom-components';
import styled from 'styled-components';
import { mixins } from '../../css';

export const StyledHeaderCol = styled(Grid.Col)`
  display: flex;
  align-items: center;
  padding-top: ${mixins.pxToRem(10)};
  margin-bottom: ${mixins.pxToRem(8)};
`;

export const StyledBackIcon = styled.div`
  cursor: pointer;
  padding-right: ${mixins.pxToRem(15)};
`;

export const TitleSection = styled.div`
  max-width: calc(100% - 25px);
  flex-grow: 1;
  padding-right: ${mixins.pxToRem(15)};
  display: flex;
  align-items: baseline;
  * {
    margin: 0;
  }
`;

export const TitleSpan = styled.span`
  display: inline-block;
  max-width: calc(100% - 25px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
